/* FamilyGiftMall header behaviour: sticky-on-scroll, mobile drawer (body lock),
   predictive search overlay (debounced /search/suggest.json). Cart drawer open is
   handled by Dawn's CartDrawer (auto-wires #cart-icon-bubble). */
(function () {
  'use strict';

  /* ---- sticky on scroll ---- */
  var head = document.querySelector('.fgm-head');
  if (head) {
    var onScroll = function () {
      head.classList.toggle('is-scrolled', window.scrollY > 8);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  var body = document.body;
  function lock() { body.classList.add('fgm-no-scroll'); }
  function unlock() {
    if (!document.querySelector('.fgm-drawer-scrim.is-open, .fgm-overlay.is-open')) {
      body.classList.remove('fgm-no-scroll');
    }
  }

  /* ---- mobile drawer ---- */
  var drawerScrim = document.querySelector('.fgm-drawer-scrim');
  function openDrawer() { if (drawerScrim) { drawerScrim.classList.add('is-open'); lock(); var f = drawerScrim.querySelector('input, a, button'); if (f) f.focus(); } }
  function closeDrawer() { if (drawerScrim) { drawerScrim.classList.remove('is-open'); unlock(); } }
  document.querySelectorAll('[data-fgm-drawer-open]').forEach(function (b) { b.addEventListener('click', openDrawer); });
  document.querySelectorAll('[data-fgm-drawer-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
  if (drawerScrim) drawerScrim.addEventListener('click', function (e) { if (e.target === drawerScrim) closeDrawer(); });

  /* ---- search overlay + predictive ---- */
  var overlay = document.querySelector('.fgm-overlay');
  var input = overlay && overlay.querySelector('.fgm-search-field input');
  var resultsCol = overlay && overlay.querySelector('.fgm-search-results');
  var resultsWrap = overlay && overlay.querySelector('.fgm-search-prods');
  var clearBtn = overlay && overlay.querySelector('.fgm-search-clear');

  function openSearch() { if (overlay) { overlay.classList.add('is-open'); lock(); if (input) setTimeout(function () { input.focus(); }, 60); } }
  function closeSearch() { if (overlay) { overlay.classList.remove('is-open'); unlock(); } }
  document.querySelectorAll('[data-fgm-search-open]').forEach(function (b) { b.addEventListener('click', openSearch); });
  document.querySelectorAll('[data-fgm-search-close]').forEach(function (b) { b.addEventListener('click', closeSearch); });
  if (overlay) overlay.addEventListener('click', function (e) { if (e.target === overlay) closeSearch(); });

  document.addEventListener('keyup', function (e) {
    if (e.key === 'Escape') { closeSearch(); closeDrawer(); }
  });

  var debounce;
  function predictive(q) {
    var base = (window.routes && window.routes.predictive_search_url) || '/search/suggest';
    var url = base + '.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product,query&resources[limit]=6&resources[options][unavailable_products]=last';
    fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!resultsWrap || !resultsCol) return;
        var products = (((data || {}).resources || {}).results || {}).products || [];
        if (!products.length) {
          resultsWrap.innerHTML = '<p class="fgm-search-empty">No matches yet. Try another word.</p>';
        } else {
          resultsWrap.innerHTML = products.map(function (p) {
            var img = p.image || (p.featured_image && p.featured_image.url) || '';
            var media = img
              ? '<img src="' + img + '" alt="" width="56" height="56">'
              : '<span class="ph"></span>';
            var price = p.price != null ? '<span class="price">' + p.price + '</span>' : '';
            return '<a class="fgm-spcard" href="' + p.url + '">' + media +
              '<span><b>' + p.title + '</b>' + price + '</span></a>';
          }).join('');
        }
        resultsCol.hidden = false;
      })
      .catch(function () { if (resultsCol) resultsCol.hidden = true; });
  }

  if (input) {
    input.addEventListener('input', function () {
      var q = input.value.trim();
      if (clearBtn) clearBtn.hidden = q.length === 0;
      clearTimeout(debounce);
      if (q.length < 2) { if (resultsCol) resultsCol.hidden = true; return; }
      debounce = setTimeout(function () { predictive(q); }, 220);
    });
  }
  if (clearBtn) clearBtn.addEventListener('click', function () {
    if (input) { input.value = ''; input.focus(); }
    if (resultsCol) resultsCol.hidden = true;
    clearBtn.hidden = true;
  });
})();
